import api from "../api"

export async function deleteOrganization(organizationApikey){
  const organizationKey = `organization:${organizationApikey}`
  const deletingKey = `${organizationKey}:deleting`
  const deletingErrorKey = `${deletingKey}:error`

  if (this.getState()[deletingKey]) return

  this.setState({
    [deletingKey]: true,
    [deletingErrorKey]: undefined,
  })

  try {
    await api.superAdminDeleteOrganization({ organizationApikey })
    this.setState({
      [deletingKey]: undefined,
      [organizationKey]: undefined,
    })

    await this.takeAction('organizations.load')
  } catch (error) {
    this.setState({
      [deletingKey]: undefined,
      [deletingErrorKey]: error,
    })
  }

}
